(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[537],{

/***/ 83849:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[category]",
      function () {
        return __webpack_require__(61984);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CategoryNavigation_CategoryNavigation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/ui/links/CustomA.tsx
var CustomA = __webpack_require__(70378);
;// CONCATENATED MODULE: ./components/shop/CategoryNavigation/CategoryNavigationItem.tsx








var CategoryNavigationItem = function(param) {
    var _category = param.category, slug = _category.slug, name = _category.name, url = _category.smallImage.url, _isSelected = param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected;
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/shop/".concat(slug, "#product-list"),
        passHref: true,
        scroll: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomA/* default */.Z, {
            className: classes.container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: url,
                        quality: 75,
                        width: 133,
                        height: 133
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: classnames_default()(classes.text, isSelected && classes.textSelected),
                    variant: "h6",
                    component: "h2",
                    children: name
                })
            ]
        })
    });
};
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: {
            display: "flex",
            flexDirection: "column"
        },
        text: (0,_define_property/* default */.Z)({
            fontWeight: 400,
            fontSize: "0.85rem",
            textAlign: "center"
        }, "&:hover", {
            textDecoration: "underline"
        }),
        textSelected: {
            fontWeight: 700,
            color: theme.palette.primary.main
        }
    };
});
/* harmony default export */ var CategoryNavigation_CategoryNavigationItem = (CategoryNavigationItem);

;// CONCATENATED MODULE: ./components/shop/CategoryNavigation/CategoryNavigation.tsx





var CategoryNavigation = function(param) {
    var categories = param.categories, _categorySlug = param.categorySlug, categorySlug = _categorySlug === void 0 ? "" : _categorySlug;
    var classes = CategoryNavigation_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: classes.container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.grid,
            children: categories.map(function(category) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryNavigation_CategoryNavigationItem, {
                    category: category,
                    isSelected: categorySlug === category.slug
                }, category.sys.id);
            })
        })
    });
};
var CategoryNavigation_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: {
            marginBottom: theme.spacing(6)
        },
        grid: (0,_define_property/* default */.Z)({
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))"
        }, theme.breakpoints.up("sm"), {
            gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))",
            gap: 4
        })
    };
});
/* harmony default export */ var CategoryNavigation_CategoryNavigation = (CategoryNavigation);


/***/ }),

/***/ 12030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ loaders_PageLoader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
;// CONCATENATED MODULE: ./public/logo-no-text.svg
/* harmony default export */ var logo_no_text = ({"src":"/_next/static/media/logo-no-text.a1a02b2b.svg","height":114,"width":114});
;// CONCATENATED MODULE: ./components/ui/loaders/PageLoader.tsx
/* eslint-disable @next/next/no-img-element */ 



var PageLoader = function() {
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: classes.container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: classes.imageContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: logo_no_text
            })
        })
    });
};
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: {
            width: "100vw",
            height: "100vh",
            backgroundColor: theme.palette.common.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        imageContainer: {
            width: 200,
            height: 200
        }
    };
});
/* harmony default export */ var loaders_PageLoader = (PageLoader);


/***/ }),

/***/ 61984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _category_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/layout/Layout.tsx + 13 modules
var Layout = __webpack_require__(78690);
// EXTERNAL MODULE: ./components/shop/CategoryNavigation/CategoryNavigation.tsx + 1 modules
var CategoryNavigation = __webpack_require__(45243);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/ui/links/CustomA.tsx
var CustomA = __webpack_require__(70378);
;// CONCATENATED MODULE: ./public/icons/eye.svg
/* harmony default export */ var eye = ({"src":"/_next/static/media/eye.c23cf1a4.svg","height":512,"width":512});
// EXTERNAL MODULE: ./utils/apollo/vars/cartVar.ts
var cartVar = __webpack_require__(87543);
// EXTERNAL MODULE: ./utils/apollo/vars/showCartVar.ts
var showCartVar = __webpack_require__(66660);
// EXTERNAL MODULE: ./utils/helpers/analytics/events.ts + 2 modules
var events = __webpack_require__(23073);
;// CONCATENATED MODULE: ./public/icons/badges/new.svg
/* harmony default export */ var badges_new = ({"src":"/_next/static/media/new.52f1ab94.svg","height":426,"width":416});
;// CONCATENATED MODULE: ./components/shop/ProductCard/Badge/Badge.tsx





var Badge = function(param) {
    var featured = param.featured, discount = param.discount;
    var classes = useStyles();
    if (discount) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.discountContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "h3",
                    component: "span",
                    className: classes.discountAmount,
                    children: [
                        "-",
                        Math.ceil(discount)
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "span",
                    className: classes.discountPercent,
                    children: "%"
                })
            ]
        })
    });
    if (featured) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: badges_new
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: {
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: 2,
            width: 70,
            height: 70,
            overflow: "hidden"
        },
        discountContainer: {
            position: "absolute",
            width: "125%",
            height: "125%",
            backgroundColor: "#D882A7",
            rotate: "45deg",
            top: "-55%",
            right: "-55%",
            borderRadius: 8,
            whiteSpace: "nowrap",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
            paddingBottom: 4,
            gap: 2,
            paddingLeft: 4
        },
        discountAmount: {
            color: theme.palette.common.white
        },
        discountPercent: {
            color: theme.palette.common.white,
            fontSize: "0.75rem",
            marginBottom: 2
        }
    };
});
/* harmony default export */ var Badge_Badge = (Badge);

// EXTERNAL MODULE: ./components/ui/textFormaters/PriceText.tsx
var PriceText = __webpack_require__(88241);
// EXTERNAL MODULE: ./utils/helpers/products/calculatePrice.ts
var calculatePrice = __webpack_require__(23963);
;// CONCATENATED MODULE: ./components/shop/ProductCard/ProductCard.tsx















var ProductCard = function(param) {
    var _product = param.product, id = _product.sys.id, slug = _product.slug, url = _product.mainImage.url, price = _product.price, discount = _product.discount, name = _product.name, _category = _product.category, categorySlug = _category.slug, categoryName = _category.name, available = _product.available, color = _product.color, featuredImage = _product.featuredImage, productItemCode = _product.productItemCode, cartItemIds = _product.cartItemIds, _index = param.index, index = _index === void 0 ? 0 : _index;
    var classes = ProductCard_useStyles();
    var handleBuy = function(e) {
        e.preventDefault();
        if (cartItemIds === null || cartItemIds === void 0 ? void 0 : cartItemIds.length) {
            cartItemIds.forEach(function(cartItemId) {
                return (0,cartVar/* addToCart */.Xq)(cartItemId);
            });
        } else {
            (0,cartVar/* addToCart */.Xq)(id);
        }
        (0,showCartVar/* openCart */.LA)();
        events/* default.addToCart */.Z.addToCart(categoryName, name, color, 1, (0,calculatePrice/* calculatePrice */.e)(price, discount), productItemCode);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/shop/".concat(categorySlug, "/").concat(slug),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomA/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.card,
                children: [
                    !!available && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge_Badge, {
                        featured: !!featuredImage,
                        discount: discount
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: classes.cardHover,
                        zIndex: 1000 - index,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            className: classes.hoverContent,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.eyeButton,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: eye,
                                        alt: "Eye",
                                        height: 52,
                                        width: 52,
                                        className: classes.animatedEye,
                                        title: "Переглянути"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "primary",
                                    size: "large",
                                    onClick: handleBuy,
                                    className: classnames_default()(classes.buyButton, !available && classes.buyButtonNotAvailable),
                                    disabled: available <= 0,
                                    children: available > 0 ? "У кошик" : "Не в наявності"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: classes.imageContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: url,
                            quality: 75,
                            width: 384,
                            height: 384,
                            className: classnames_default()(classes.image, !available && classes.notAvailable)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: classes.content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                className: classnames_default()(classes.title, !available && classes.notAvailable),
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                component: "p",
                                color: "primary",
                                className: classnames_default()(classes.price, !available && classes.notAvailable),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText/* default */.Z, {
                                    price: price,
                                    discount: discount,
                                    isAvailable: !!available
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var ProductCard_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        card: (0,_define_property/* default */.Z)({
            position: "relative",
            transition: "box-shadow 500ms",
            marginBottom: 86,
            height: "calc(100% - 86px)",
            display: "flex",
            flexDirection: "column"
        }, theme.breakpoints.up("md"), {
            marginBottom: 0,
            height: "100%",
            "&:hover": {
                boxShadow: "0px 0px 26.68px 2.32px rgba(0, 0, 0, 0.13)",
                "& $cardHover": {
                    opacity: 1
                },
                "& $image": {
                    transform: "perspective(1000px) rotateX(35deg) rotateY(4deg) rotateZ(-30deg) scale(1.25,1.25)"
                }
            }
        }),
        cardClicked: (0,_define_property/* default */.Z)({}, theme.breakpoints.up("md"), {
            boxShadow: "0px 0px 26.68px 2.32px rgba(0, 0, 0, 0.13)",
            "& $cardHover": {
                opacity: 1
            },
            "& $image": {
                transform: "perspective(1000px) rotateX(35deg) rotateY(4deg) rotateZ(-30deg) scale(1.25,1.25)",
                cursor: "pointer"
            }
        }),
        cardHover: (0,_define_property/* default */.Z)({
            position: "absolute",
            top: "calc(100% - 16px)",
            left: 0,
            height: 86,
            width: "100%",
            opacity: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end"
        }, theme.breakpoints.up("md"), {
            top: "calc(100% - 6px)",
            opacity: 0,
            transition: "all 500ms",
            boxShadow: "0px 30px 26.68px 2.32px rgba(0, 0, 0, 0.13)"
        }),
        hoverContent: {
            backgroundColor: theme.palette.common.white,
            paddingBottom: theme.spacing(4),
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: theme.spacing(3)
        },
        eyeButton: (0,_define_property/* default */.Z)({
            flexGrow: 1,
            display: "none",
            alignItems: "center",
            paddingRight: theme.spacing(2)
        }, theme.breakpoints.up("md"), {
            display: "flex"
        }),
        buyButton: (0,_define_property/* default */.Z)({
            flexGrow: 2,
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
            fontSize: "1rem",
            height: 41,
            paddingBottom: theme.spacing(0.5)
        }, theme.breakpoints.up("md"), {
            fontSize: "1.25rem",
            height: 47,
            paddingBottom: theme.spacing(1)
        }),
        buyButtonNotAvailable: (0,_define_property/* default */.Z)({
            fontSize: "0.75rem"
        }, theme.breakpoints.up("md"), {
            fontSize: "1rem"
        }),
        title: (0,_define_property/* default */.Z)({
            textAlign: "center",
            marginBottom: theme.spacing(2),
            fontSize: "1rem"
        }, theme.breakpoints.up("md"), {
            fontSize: "1.25rem"
        }),
        price: (0,_define_property/* default */.Z)({
            textAlign: "center",
            fontSize: "0.875rem"
        }, theme.breakpoints.up("md"), {
            fontSize: "1.25rem"
        }),
        content: {
            width: "100%",
            padding: theme.spacing(2),
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
        },
        imageContainer: {
            overflow: "hidden"
        },
        image: {
            transition: "transform 500ms ease-in",
            transform: "perspective(1000px) rotateX(0deg) rotateY(0deg) rotateZ(0deg)"
        },
        notAvailable: {
            opacity: 0.59
        },
        animatedEye: {
            animation: "$blink 6000ms ".concat(theme.transitions.easing.easeInOut, " infinite")
        },
        "@keyframes blink": {
            "0%, 100%": {
                transform: "scale(1, 0.05)"
            },
            "5%, 95%": {
                transform: "scale(1, 1)"
            }
        }
    };
});
/* harmony default export */ var ProductCard_ProductCard = (ProductCard);

;// CONCATENATED MODULE: ./components/shop/ProductTiles/ProductTiles.tsx





var ProductTiles = function(param) {
    var products = param.products;
    var classes = ProductTiles_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        id: "product-list",
        className: classes.container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.gridCointainer,
            children: products.map(function(product, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard_ProductCard, {
                        product: product,
                        index: index
                    })
                }, product.sys.id);
            })
        })
    });
};
var ProductTiles_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return {
        container: (0,_define_property/* default */.Z)({}, theme.breakpoints.only("xs"), {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1)
        }),
        gridCointainer: (_obj = {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridColumn: "1fr",
            gap: theme.spacing(1)
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
            gridTemplateColumns: "1fr 1fr 1fr"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            gap: theme.spacing(5)
        }), _obj)
    };
});
/* harmony default export */ var ProductTiles_ProductTiles = (ProductTiles);

// EXTERNAL MODULE: ./components/ui/loaders/PageLoader.tsx + 1 modules
var PageLoader = __webpack_require__(12030);
;// CONCATENATED MODULE: ./pages/shop/[category]/index.tsx






var CategoryPage = function(param) {
    var categories = param.categories, products = param.products, category = param.category;
    var router = (0,next_router.useRouter)();
    if (router.isFallback) return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        pageMeta: {
            title: category.metaTitle || category.name,
            description: category.metaDescription || category.description,
            imageUrl: category.image.url
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryNavigation/* default */.Z, {
                categories: categories,
                categorySlug: category.slug
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTiles_ProductTiles, {
                products: products
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _category_ = (CategoryPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [112,351,690,774,888,179], function() { return __webpack_exec__(83849); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);